<template>
    <form class="admin-plan-form" @submit.prevent="proceed" @keydown="currencyForm.errors.clear($event.target.name)">
        <div class="row admin-plan-form__row">
            <div class="col-12 col-sm-6 form-group">
                <label for="">{{trans('currency.name')}} </label>
                <input class="form-control" type="text" value="" v-model="currencyForm.name" name="name" :placeholder="trans('currency.name')">
                <show-error :form-name="currencyForm" prop-name="name"></show-error>
            </div>
            <div class="col-12 col-sm-6 form-group">
                <label for="">{{trans('currency.symbol')}}</label>
                <input class="form-control" type="text" value="" v-model="currencyForm.symbol" name="symbol" :placeholder="trans('currency.symbol')">
                <show-error :form-name="currencyForm" prop-name="symbol"></show-error>
            </div>
            <div class="col-12 col-sm-6 form-group">
                <label for="">{{trans('currency.decimal_place')}}</label>
                <input class="form-control" type="number" value="" v-model="currencyForm.decimal_place" name="decimal_place" :placeholder="trans('currency.decimal_place')">
                <show-error :form-name="currencyForm" prop-name="decimal_place"></show-error>
            </div>
        </div>

        <div class="form-group mb-0">
            <label>{{trans('currency.position')}}</label>
            <div class="d-flex flex-wrap align-items-center">
                <div class="radio radio-success mr-3 mb-1">
                    <input type="radio" value="prefix" id="position_prefix" v-model="currencyForm.position" :checked="currencyForm.position === 'prefix'" name="position" @click="currencyForm.errors.clear('position')">
                    <label for="position_prefix">{{trans('currency.prefix')}}</label>
                </div>
                <div class="radio radio-success mb-1">
                    <input type="radio" value="suffix" id="position_suffix" v-model="currencyForm.position" :checked="currencyForm.position === 'suffix'" name="position" @click="currencyForm.errors.clear('position')">
                    <label for="position_suffix">{{trans('currency.suffix')}}</label>
                </div>
            </div>
            <show-error :form-name="currencyForm" prop-name="position"></show-error>
        </div>

        <div class="admin-plan-form__switches">
            <div class="admin-plan-form__switch-row">
                <div class="admin-plan-form__switch-meta">
                    <span class="admin-plan-form__switch-label">{{trans('currency.default')}}</span>
                </div>
                <switches v-model="currencyForm.is_default" theme="bootstrap" color="success"></switches>
            </div>
        </div>
        <div class="admin-plan-form__actions">
            <button type="submit" class="btn btn-sm admin-toolbar-btn admin-toolbar-btn--solid">
                <admin-icon name="check"></admin-icon>
                <span v-if="id">{{trans('general.update')}}</span>
                <span v-else>{{trans('general.save')}}</span>
            </button>
            <router-link to="/currency" class="btn btn-sm admin-form-btn-cancel" v-show="id"><admin-icon name="close" class="mr-1"></admin-icon>{{trans('general.cancel')}}</router-link>
        </div>
    </form>
</template>


<script>
    import switches from 'vue-switches'

    export default {
        components: {switches},
        data() {
            return {
                currencyForm: new Form({
                    name : '',
                    symbol : '',
                    position: '',
                    decimal_place: '',
                    is_default: false
                })
            };
        },
        props: ['id'],
        mounted() {
            if(this.id)
                this.getCurrency();
        },
        methods: {
            proceed(){
                if(this.id)
                    this.updateCurrency();
                else
                    this.storeCurrency();
            },
            storeCurrency(){
                this.currencyForm.post('/api/currency')
                    .then(response => {
                        toastr.success(response.message);
                        this.$emit('completed');
                    })
                    .catch(error => {
                        helper.showErrorMsg(error);
                    });
            },
            getCurrency(){
                axios.get('/api/currency/'+this.id)
                    .then(response => response.data)
                    .then(response => {
                        this.currencyForm.name = response.name;
                        this.currencyForm.symbol = response.symbol;
                        this.currencyForm.position = response.position;
                        this.currencyForm.decimal_place = response.decimal_place;
                        this.currencyForm.is_default = response.is_default;
                    })
                    .catch(error => {
                        this.$router.push('/currency');
                    });
            },
            updateCurrency(){
                this.currencyForm.patch('/api/currency/'+this.id)
                    .then(response => {
                        toastr.success(response.message);
                        this.$router.push('/currency');
                    })
                    .catch(error => {
                        helper.showErrorMsg(error);
                    });
            }
        }
    }
</script>
